/**
 * Component: Albaran
 * Package: Albaran
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\albaran\Albaran.js
 *
 * Requisito funcional: RQ10-007
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera una tabla que permite listar los albaranes de venta almacenados.
 */

import React, { Component } from 'react'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import ListadoPage from '../../containers/page/ListadoPage'
import FiltrosAlbaranPage from '../../containers/albaranManual/FiltrosAlbaranPage'
import ModalAlbaranPage from '../../containers/albaranManual/ModalAlbaranPage'
import {estadoAlbaran as estadoAlbaranConstants} from '../../constants/albaran'
import { date_parser, dateTimeZones } from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'

class AlbaranManual extends Component {
  componentDidMount () {
    document.title = this.props.t('MENU.PEDIDO.REGISTRO_ALBARANES') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')
    let fechaActual = date_parser(dateTimeZones(this.props.auth.zonaHorariaString), this.props.auth.formaFechaHora)
    this.props.actions.fetchAlbaranesManual({desde: fechaActual, 'seleccionar-todo': false})
  }

  render () {
    const {
      list = [], checkedFiltrosAlbaran, t, numeroRegistrosPorPagina, paginaActual,
      actions: {abrirDetallesAlbaranManual, onDeleteAlbaranManual, imprimirAlbaranManual}
    } = this.props

    const tKey = 'ALBARANES.'
    const idElemento = 'idAlbaran'
    const table = {
      id: 'albaranTable',
      multiHeader: false,
      hasCheckbox: false,
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      onEdit: (row) => abrirDetallesAlbaranManual(row.idAlbaranManual),
      mostrarDuplicar: false,      
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ALBARANES] > 1),
      onDelete: (row) => onDeleteAlbaranManual(row.idAlbaranManual),
      mostrarAlbaran:true,
      mostrarImprimirAlbaran:true,
      onImprimirAlbaran:(row) => imprimirAlbaranManual(row.idAlbaranManual),
      mostrarCambioEstado: false,
      columns: [
        {id: 'numeroAlbaran', name: t(tKey + 'COLUMNS.NUM_ALBARAN')},        
        {id: 'cliente', name: t(tKey + 'COLUMNS.CLIENTE')},
        {id: 'granja', name: t('PEDIDOS.CLIENTE.MODAL_DIRECCIONES.GRANJA')},        
        {id: 'fechaCreacion', name: t(tKey + 'COLUMNS.FECHA'), type: 'fecha'},
        {id: 'numeroDosis', name: t(tKey + 'COLUMNS.NUMERO_DOSIS'), type: 'numero', numDecimales: 0},             
      ],
      rows:list.albaranes && Object.keys(list.albaranes).length > 0 ? list.albaranes : [],
      filtros: <FiltrosAlbaranPage idElemento={idElemento} />,
      leyenda: [],
      initialValues: {},
      showModal: this.props.showModalAlbaran
    }
    table.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          table.initialValues['check' + row[idElemento]] = checkedFiltrosAlbaran
        }
      }
    )   

    return (
      <div>
        <SimpleModalPage/>
        <h2 className="page-title" style={{display: 'inline-block'}}>{t('MENU.PEDIDO.REGISTRO_ALBARANES')}</h2>
        <MensajeAlertaPage/>
        <ModalAlbaranPage/>
        <ListadoPage t_key={tKey} table={table} noTitle={true}>
        </ListadoPage>        
      </div>
    )
  }
}

export default AlbaranManual